import React from 'react';
import { Card, CardHeader, CardBody, CardSubtitle, CardText, Row, Col, Button, Badge } from 'reactstrap';
import { FaEdit, FaBell } from "react-icons/fa";
import moment from 'moment';
import { FaEnvelope, FaIdBadge } from 'react-icons/fa';
import { PiGolfBold } from "react-icons/pi";

const EventCard = ({ event, onEdit, onCheckIn, showDate = false }) => {
    const normalizedState = String(event?.state || event?.status || '').toLowerCase();
    const isCancelledEvent = event?.cancelled === true || normalizedState === 'cancelled' || normalizedState === 'canceled' || normalizedState.includes('cancel');

    return (
    <Card className='mb-2 flex-fill' outline>
        <CardHeader>
            <Row className='justify-content-between align-items-center'>
                <Col xs="auto">
                    <span className='h6 mb-0 fw-bold'>{event.customer_name}</span>
                    {event.check_in_state && (
                        <Badge
                            color={event.checkInDetails?.color_code}
                            pill
                            className={`p-2 ms-2 ${event.checkInDetails?.color_code === 'warning' ? 'text-dark' : 'text-light'}`}
                            style={{ cursor: 'pointer' }}
                            onClick={onCheckIn}
                        >
                            {event.checkInDetails?.title}
                        </Badge>
                    )}
                    {event.state === 'NoShow' && (
                        <Badge 
                            color='danger' 
                            pill 
                            className='p-2 ms-2'
                            style={{ cursor: 'pointer' }}
                            onClick={onCheckIn}
                        >
                                No Show
                        </Badge>
                    )}
                </Col>
                <Col xs="auto" className='text-end'>
                    {event.first_time_user && (
                        <>
                            <span className='text-primary fw-semibold'>FIRST-TIME USER</span>
                            <FaBell className='text-primary ms-1' />
                        </>
                    )}
                </Col>
            </Row>
        </CardHeader>

        <CardBody className='d-flex flex-column'>
            <CardSubtitle className='mb-2'>
                <Row className='justify-content-between'>
                    <Col xs="auto">
                        {showDate && (<div>{moment(event.start).format('dddd, MMMM D, YYYY')}</div>)}
                        {moment(event.start).format('LT')} - {moment(event.end).format('LT')} <strong>({event.resourceDetails?.name})</strong>
                    </Col>
                    <Col xs="auto">
                        {isCancelledEvent ? (
                            <Badge color='danger' pill className='px-3 py-2'>
                                CANCELLED
                            </Badge>
                        ) : (
                            <Button color='link' onClick={onEdit}>
                                <FaEdit style={{ cursor: 'pointer', fontSize: '1.5rem' }} color='green' />
                            </Button>
                        )}
                    </Col>
                </Row>
            </CardSubtitle>

            <CardText className='flex-grow-1 small'>
                {event.serviceDetails && (<>
                    {event.serviceDetails?.title} {event.discountCodeDetails && (<span>({event.discountCodeDetails.description})</span>)}<br />
                </>)}
                {event.online_booking && <strong className='text-primary'>Booked Online</strong>}<br />

                {event.league_date && (
                    <>
                        <strong>League Notes:</strong> Week {event.league_date?.week} ({event.league_team?.league_name})
                        {event.league_date?.notes && ` - ${event.league_date.notes}`}
                        <br />
                    </>
                )}
                {event.notes && (<><strong>Internal Notes:</strong> {event.notes}<br /></>)}
                {event.customerNotes && (<><strong>Customer Notes:</strong> {event.customerNotes}<br /></>)}
            </CardText>

            {event.league_date && event.league_team?.players && (
                <Row className="mt-1 mb-2 g-2">
                    {event.league_team.players.map(player => (
                        <Col key={player.id} xs="12" sm="12" md="12" lg="12">
                            <Card className="h-100 shadow-sm">
                                <CardHeader className="bg-light">
                                    <strong>{player.first_name} {player.last_name}</strong>
                                </CardHeader>
                                <CardBody>
                                    <div className="text-muted" style={{ fontSize: '0.9em' }}>
                                        {player.email && (
                                            <>
                                                <FaEnvelope className="me-1 text-secondary" />
                                                <a href={`mailto:${player.email}`}>{player.email}</a>
                                                <br />
                                            </>
                                        )}
                                        {player.alternate_id && (
                                            <>
                                                <FaIdBadge className="me-1 text-secondary" />{player.alternate_id}
                                                <br />
                                            </>
                                        )}
                                        {player.tees && (<>
                                            <PiGolfBold className="me-1 text-secondary" />{player.tees}
                                            <br />  
                                        </>)}
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    ))}
                </Row>
            )}

            {!event.check_in_state && event.state === 'Booked' && moment(event.start).isSameOrBefore(moment(), 'day') && (
                <Button className='w-100 mt-auto' onClick={onCheckIn}>Check In</Button>
            )}
        </CardBody>
    </Card>
    );
};

export default EventCard;
